import type { FacilityDto } from '@peritasai/types';

export class FacilityEntity {
  public readonly id: string;
  public readonly name: string;
  public readonly address: string;
  public readonly startTime: string;
  public readonly endTime: string;
  public readonly timeZone: string;
  public readonly contactInfo: string | null;

  constructor(dto: FacilityDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.address = dto.address;
    this.startTime = dto.startTime;
    this.endTime = dto.endTime;
    this.timeZone = dto.timeZone;
    this.contactInfo = dto.contactInfo ?? null;
  }
}
